var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClientHomeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 32,
    height: 32,
    rx: 4,
    fill: "#01052F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.746 14.2323L16.3459 7.13907C16.1527 6.95364 15.8473 6.95364 15.6541 7.13907L8.2467 14.2397C8.08997 14.3964 8 14.6123 8 14.833C8 15.2924 8.37402 15.6664 8.83337 15.6664H10V21.9997C10 22.5517 10.448 22.9997 11 22.9997H13.8334C14.1094 22.9997 14.3334 22.7757 14.3334 22.4997V18.1664C14.3334 18.075 14.408 17.9997 14.5 17.9997H17.5C17.5913 17.9997 17.6666 18.075 17.6666 18.1664V22.4997C17.6666 22.7757 17.8906 22.9997 18.1666 22.9997H21C21.552 22.9997 22 22.5517 22 21.9997V15.6664H23.1666C23.626 15.6664 24 15.2924 24 14.833C24 14.6123 23.91 14.3964 23.746 14.2323Z",
    fill: "#01052F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientHomeIcon);
export default __webpack_public_path__ + "static/media/ClientHomeIcon.6c367d367639fde231db1a6c23d582f3.svg";
export { ForwardRef as ReactComponent };